function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fileImageApi } from '@/api/systemSetting';
import { communityContentSave, communityContentUpdateById } from '@/api/community/community';
import ueditorFrom from '@/components/ueditorFrom'; // import uploadVideo from '@/components/uploadVideo'

import uploadImage from '@/components/uploadImage';
import uploadByOss from '@/components/uploadByOss';
import addTopic from './addTopic';
import addCurrency from './addCurrency';
import addIssuer from './addIssuer';
import addLink from './addLink';
import { languageType } from '@/utils/enum';
export default {
  name: 'AddCommunity',
  components: {
    ueditorFrom: ueditorFrom,
    addTopic: addTopic,
    addIssuer: addIssuer,
    addLink: addLink,
    // uploadVideo,
    uploadByOss: uploadByOss,
    uploadImage: uploadImage,
    addCurrency: addCurrency
  },
  data: function data() {
    return {
      languageType: languageType,
      formModal: {
        id: '',
        createBy: '',
        // 发布人
        memberName: '',
        contentType: '',
        // 分类
        title: '',
        // 标题
        topicId: [],
        // 话题
        topicList: [],
        // 话题列表
        currencyId: '',
        // 币种id
        currencyList: [],
        // 币种列表
        content: '',
        // 内容
        image: '',
        // 图片
        video: '',
        // 视频
        videoDuration: '',
        // 视频总时长
        videoAspectRatioType: '',
        // 视频宽屏 类型
        videoAspectRatio: '',
        // 视频比例
        selfFlag: 0,
        // 自营
        topFlag: 0,
        // 置顶
        url: [],
        // 超链接
        likeNum: '',
        // 点赞数
        discussNum: '',
        // 评论数
        forwardNum: '',
        // 转发数
        visitNum: '',
        // 浏览量
        showEnable: true,
        // 状态
        language: 'cn',
        // 语言
        auditStatus: 1 // 审核通过

      },
      dnamicSelect: [{
        valule: '1',
        label: '开启'
      }, {
        value: '0',
        label: '隐藏'
      }],
      memberList: {},
      // 话题
      linkList: [],
      companyUrlList: [],
      tableFrom: {},
      // table 筛选条件
      comeFrom: [{
        value: '1',
        label: '纯文本'
      }, {
        value: '2',
        label: '图文结合'
      }, {
        value: '3',
        label: '文+视频'
      }],
      articleSelect: [{
        value: 1,
        label: '是'
      }, {
        value: 0,
        label: '否'
      }],
      rules: {
        createBy: [{
          required: true,
          message: '请输入发布人',
          trigger: 'blur'
        }],
        contentType: [{
          required: true,
          message: '请输入分类',
          trigger: 'blur'
        }],
        topicId: [{
          required: true,
          message: '请输入话题',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          message: '图片不能为空',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '超链接不能为空',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '内容不能为空',
          trigger: 'blur'
        }]
      },
      formDisable: false,
      // 禁用状态
      statue: 1,
      coincelebrityData: {},
      setting: {
        // 弹窗
        title: '添加动态',
        visible: false
      },
      listLoading: true,
      // table Loading
      multipleSelection: [],
      // table 选中集
      // tag 标签
      inputVisible: false,
      inputValue: '' // tag 标签结束

    };
  },
  mounted: function mounted() {
    this.formDisable = this.$route.query.formDisable !== '0';
    this.formModal = JSON.parse(decodeURIComponent(this.$route.query.formModal));
    this.tableFrom = this.$route.params.screening;
    console.log(this.$route, 'this.tableFrom');

    if (this.formModal.createBy) {
      this.coincelebrityData.nickname = this.formModal.memberName;
      this.coincelebrityData.id = this.formModal.createBy;
    }

    if (this.formModal.image) {
      if (this.formModal.image.includes('video/snapshot')) {
        this.formModal.image = [this.formModal.image];
      } else {
        this.formModal.image = this.formModal.image.split(',');
      }
    } else {
      this.formModal.image = '';
    }

    this.statue = this.$route.query.statue;
  },
  methods: {
    getUploadFile: function getUploadFile(val) {
      console.log(val, 'val');
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      this.setting.visible = false; // 调用父组件 刷新页面

      this.$emit('getList');
    },
    handleVideo: function handleVideo(video) {
      this.formModal.video = video;
      console.log(this.formModal.video, 'this.formModal.video ');
    },
    // 新增 video 需求添加方法
    handleVideoList: function handleVideoList(list) {
      this.formModal.videoAspectRatio = list.videoAspectRatio;
      this.formModal.videoAspectRatioType = list.videoAspectRatioType;
      this.formModal.videoDuration = list.videoDuration;
    },
    handleImage: function handleImage(image) {
      console.log(image, 'vide');
      this.formModal.image = image;
    },
    handerTpye: function handerTpye(val) {
      if (this.formModal.type === 2) {
        // this.formModal.content = ''
        this.rules.content[0].required = false;
      } else {
        this.rules.content[0].required = true;
      }
    },
    handleList: function handleList(val) {
      // 弹窗回调
      this.coincelebrityData = val;
      this.formModal.createBy = val.id;
      this.formModal.memberName = val.nickname;
    },
    handleTopicList: function handleTopicList(val) {
      // 合并
      // const newArray = [...this.formModal.topicList, ...val]
      // 去重
      var nArr = val.filter(function (currentValue, currentIndex, selfArr) {
        return selfArr.findIndex(function (x) {
          return x.id === currentValue.id;
        }) === currentIndex;
      });

      if (nArr.length < 4) {
        this.formModal.topicList = nArr;
      } else {
        this.$message.error('话题最多三个！');
      } // this.topicList = val


      this.formModal.topicId = this.formModal.topicList.map(function (item) {
        return item.id;
      });
    },
    handleCurrencyList: function handleCurrencyList(val) {
      // const newArray = [...this.formModal.currencyList, ...val]
      this.formModal.currencyList = val;
      this.formModal.currencyId = this.formModal.currencyList.map(function (item) {
        return item.id;
      });
    },
    handleLink: function handleLink(val) {
      if (this.linkList.length < 3) {
        this.linkList.push(val);
      } else {
        this.$message.error('超链接最多两个！');
      }

      console.log(this.linkList, '进来这里'); // this.topicList = val
    },
    handleLinkClose: function handleLinkClose(index) {
      this.linkList.splice(index, 1);
    },

    /**
     * @param {Number} index 数组当前下标
     * @param {String} val 当前数组属性
     * @param {String} id 当前formModal对象里面数组
     * @query 关闭切换当前属性
     */
    handleTopicClose: function handleTopicClose(index, val, id) {
      this.formModal[val].splice(index, 1);

      if (this.formModal[id]) {
        if (Array.isArray(this.formModal[id])) {
          this.formModal[id].splice(index, 1);
        } else {
          var currencyId = this.formModal[id].split(',');
          currencyId.splice(index, 1);
          this.formModal[id] = currencyId;
        }
      }
    },
    // 弹窗标签
    handleTagClose: function handleTagClose(tag) {
      // this.formModal.label.splice(this.formModal.label.indexOf(tag), 1)
      this.coincelebrityData = {};
      this.formModal.createBy = ''; // this.formModal.id = ''
    },
    showInput: function showInput() {
      this.$refs.addIssuer.setting.visible = true;
      this.$refs.addIssuer.setting.title = '选择用户';
      this.$refs.addIssuer.coincelebrityRadio = '';
      this.$refs.addIssuer.getList();
    },
    showTopic: function showTopic() {
      this.$refs.addTopic.setting.visible = true;
      this.$refs.addTopic.setting.title = '选择话题';
      this.$refs.addTopic.coincelebrityRadio = '';
      this.$refs.addTopic.coincelebrityData = JSON.parse(JSON.stringify(this.formModal.topicList)) ? JSON.parse(JSON.stringify(this.formModal.topicList)) : [];
      this.$refs.addTopic.getList();
    },
    showCurrency: function showCurrency() {
      this.$refs.addCurrency.setting.visible = true;
      this.$refs.addCurrency.setting.title = '选择关联币种';
      this.$refs.addCurrency.coincelebrityRadio = '';
      this.$refs.addCurrency.coincelebrityData = JSON.parse(JSON.stringify(this.formModal.currencyList)) ? JSON.parse(JSON.stringify(this.formModal.currencyList)) : [];
      this.$refs.addCurrency.getList();
    },
    showLink: function showLink() {
      if (this.linkList.length > 1) {
        this.$message.error('超链接最多两个！');
      }

      this.$refs.addLink.setting.visible = true;
      this.$refs.addLink.setting.title = '添加超链接';
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;

      if (inputValue) {
        this.formModal.label.push(inputValue);
      }

      this.inputVisible = false;
      this.inputValue = '';
    },
    // 弹窗标签结束
    // 上传头像
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var _this = this;

      var formData = new FormData(); // if (param.file.size / (1024 * 1024).toFixed(2) >= 1) {
      //   this.$message.error('图片最大不能超过1Mb')
      //   return
      // }

      var data = {
        // model: this.modelName ? this.modelName : this.$route.path.split('/')[1],
        // pid: this.tableData.pid
        fileTypeCode: 'img'
      };
      formData.append('file', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      fileImageApi(formData, data, undefined).then(function (res) {
        if (!_this.formModal.image) {
          _this.formModal.image = [];
        }

        loading.close();

        _this.formModal.image.push(res.url);

        console.log(_this.formModal.image);

        _this.$message.success('上传成功');

        _this.$forceUpdate();
      }).catch(function (res) {
        loading.close();
      });
    },
    resetFields: function resetFields() {
      this.$refs.formModal.resetFields();
      this.coincelebrityData = {};
      this.formModal.topicList = [];
      this.linkList = [];
    },
    settingEvent: function settingEvent() {
      var _this2 = this;

      this.$refs.formModal.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid) {
          var formModal;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 23;
                    break;
                  }

                  formModal = _objectSpread({}, _this2.formModal);

                  _this2.linkList.forEach(function (v, i) {
                    formModal['link' + (i + 1)] = "".concat(v);
                  });

                  formModal.topicId = "".concat(formModal.topicId || '');
                  formModal.currencyId = "".concat(formModal.currencyId || '');
                  formModal.image = "".concat(formModal.image || '');

                  if (!formModal.video && !formModal.image) {
                    formModal.contentType = 1;
                  } else if (formModal.video) {
                    formModal.contentType = 3;
                  } else if (formModal.image) {
                    formModal.contentType = 2;
                  }

                  _context.prev = 7;

                  if (!(Number(_this2.statue) !== 1)) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 11;
                  return communityContentUpdateById(formModal);

                case 11:
                  _this2.$message.success('编辑成功');

                  _context.next = 17;
                  break;

                case 14:
                  _context.next = 16;
                  return communityContentSave(formModal);

                case 16:
                  _this2.$message.success('添加成功');

                case 17:
                  // 重置
                  _this2.$router.push({
                    name: 'CommunityDynamicHome',
                    params: {
                      screening: _this2.tableFrom
                    }
                  });

                  _this2.resetFields();

                  _context.next = 23;
                  break;

                case 21:
                  _context.prev = 21;
                  _context.t0 = _context["catch"](7);

                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[7, 21]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};